module.exports = __webpack_public_path__ + "static/img/top-img.98915091.png";